import type { ShowType } from '@fetmode/types';

const CAM_BADGE_LABELS: Record<ShowType, string> = {
  MAIN_STAGE: 'Public',
  PARTY: 'Party',
  TICKET: 'Ticket',
  CLUB: 'Club',
  VIP: 'VIP',
  EXCLUSIVE: 'Private',
  PEEP: 'Peep',
};

const CAM_BADGE_CLASSES: Record<ShowType, string> = {
  MAIN_STAGE: 'thumb-card__badge--public',
  PARTY: 'thumb-card__badge--party',
  TICKET: 'thumb-card__badge--ticket',
  CLUB: 'thumb-card__badge--club',
  VIP: 'thumb-card__badge--vip',
  EXCLUSIVE: 'thumb-card__badge--private',
  PEEP: 'thumb-card__badge--peep',
};

export function camBadgeLabel(type: ShowType): string {
  return CAM_BADGE_LABELS[type];
}

export function camBadgeClass(type: ShowType): string {
  return CAM_BADGE_CLASSES[type];
}
